<template>
    <v-container fluid>
    <v-row justify="space-between">
      <v-col cols="12" sm="12" md="12">
        <v-btn color="primary" icon size="20" @click="$router.go(-1)">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <p class="text-h6 text--secondary d-inline font-weight-bold">Tags Coached Classes</p>
      </v-col>
      <v-col cols="12" sm="12" md="12" align-self="center">
        <p class="secondary--text ml-4 mr-2 font-weight-bold d-inline">Tags</p>
        <v-btn
          text
          color="secondary"
          @click="dialogCreateNewFilter.show = true"
          >
          <v-icon left dark color="primary"> mdi-plus </v-icon>
          Generate new tag
        </v-btn>
        
      </v-col>
    </v-row>
    <v-row justify="start" v-if="getProTrainerFilters.length > 0">
      <v-col cols="4" v-for="(filter, i) in getProTrainerFilters" :key="i">
           <v-btn
            text
            color="secondary"
            class="mb-3"
            @click="openDialogCreate(filter.type)"
            >
            <v-icon left dark color="primary"> mdi-plus </v-icon>
            Add new {{ filter.name['ENG'] }}
            </v-btn>
           <v-btn
            text
            color="red"
            class="mb-3"
            @click="openDialogDeleteConfirm(filter)"
            >
            <v-icon left dark color="primary"> mdi-delete </v-icon>
            Delete 
            </v-btn>
            
            <v-data-table
              :headers="headers"
              :items-per-page="5"
              :items="filter.listFilters"
              fixed-header
              class="elevation-4"
            >
             <template v-slot:[`item.name`]="{ item }">
                  {{ item.name }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                 <v-btn
                    v-if="item"
                    text
                    icon
                    color="primary"
                    @click="openSubfiltersModal(item, filter.type)"
                  >
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
                <v-btn
                    v-if="item"
                    text
                    icon
                    color="secondary"
                    @click="deleteItem(filter.type, item)"
                  >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
           </v-data-table>
      </v-col>
    </v-row>
     <v-dialog
      v-model="dialogCreate.show"
      persistent
      max-width="500"
    >
      <v-card class="text-center">
       
          <v-card-title class="secondary--text">
            Create new {{ getTypeTextPlaceholder(dialogCreate.type) }}
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="11">
                 <v-text-field
                    v-model="dialogCreate.name"
                    placeholder="Name"
                    solo
                    flat
                    background-color="#efefef"
                  ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              small
              :disabled="dialogCreate.loading"
              @click="closeDialogCreate()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              small
              :disabled="dialogCreate.loading"
              :loading="dialogCreate.loading"
              @click="saveNewCreate()"
            >
              Add
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog
      v-model="dialogChildrenFilters.show"
      persistent
      max-width="500"
    >
      <v-card class="text-center">
       
          <v-card-title class="secondary--text">
            Sub-Tags of {{ dialogChildrenFilters.item.name }}
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="10">
                 <v-text-field
                    v-model="dialogChildrenFilters.newSubfilter"
                    placeholder="Add new sub-tag"
                    :disabled="dialogChildrenFilters.loading"
                    solo
                    flat
                    background-color="#efefef"
                    @keyup.enter="saveNewSubfilter()"
                  ></v-text-field>
              </v-col>
              <v-col cols="1">
                  <v-btn
                    text
                    icon
                    :disabled="dialogChildrenFilters.loading || dialogChildrenFilters.newSubfilter.length <= 0"
                    :loading="dialogChildrenFilters.loading"
                    color="primary"
                    @click="saveNewSubfilter()"
                  >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="11">
                <v-data-table
                  v-if="getProTrainerFilters.length > 0"
                  :headers="headers"
                  :items-per-page="5"
                  :items="dialogChildrenFilters.item.children"
                  no-data-text="This filter does not have subfilters"
                  fixed-header
                  class="elevation-4"
                >
                <template v-slot:[`item.name`]="{ item }">
                      {{ item.name }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        v-if="item"
                        text
                        icon
                        color="primary"
                        @click="openThirdLevelFiltersModal(item, dialogChildrenFilters.type, dialogChildrenFilters.item.name)"
                      >
                      <v-icon>mdi-format-list-bulleted</v-icon>
                    </v-btn>
                      <v-btn
                        v-if="item"
                        text
                        icon
                        color="secondary"
                        @click="deleteSubfilter(item)"
                      >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
              </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              small
              :disabled="dialogCreate.loading"
              @click="dialogChildrenFilters.show = false"
            >
              Close
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogThirdLevelFilters.show"
      persistent
      max-width="500"
    >
      <v-card class="text-center">
       
          <v-card-title class="secondary--text">
            Third level filters of {{ dialogThirdLevelFilters.item.name }}
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="10">
                 <v-text-field
                    v-model="dialogThirdLevelFilters.newThirdLevel"
                    placeholder="Add new third level"
                    :disabled="dialogThirdLevelFilters.loading"
                    solo
                    flat
                    background-color="#efefef"
                    @keyup.enter="saveNewThirdLevelFilter()"
                  ></v-text-field>
              </v-col>
              <v-col cols="1">
                  <v-btn
                    text
                    icon
                    :disabled="dialogThirdLevelFilters.loading || dialogThirdLevelFilters.newThirdLevel.length <= 0"
                    :loading="dialogThirdLevelFilters.loading"
                    color="primary"
                    @click="saveNewThirdLevelFilter()"
                  >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="11">
                <v-data-table
                  v-if="getProTrainerFilters.length > 0"
                  :headers="headers"
                  :items-per-page="5"
                  :items="dialogThirdLevelFilters.item.children"
                  no-data-text="This filter does not have third level filters"
                  fixed-header
                  class="elevation-4"
                >
                <template v-slot:[`item.name`]="{ item }">
                      {{ item.name }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        v-if="item"
                        text
                        icon
                        color="secondary"
                        @click="deleteThirdLevelFilter(item)"
                      >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
              </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              small
              :disabled="dialogThirdLevelFilters.loading"
              @click="dialogThirdLevelFilters.show = false"
            >
              Close
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCreateNewFilter.show"
      persistent
      max-width="500"
      
    >
      <v-card class="text-center pb-4 pt-4">
          <v-card-title class="secondary--text d-inline">
            Generate new tag
          </v-card-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="black" dark v-bind="attrs" v-on="on" size="32">mdi-translate</v-icon>
            </template>
            <span>Here you can choose the language of the filter to translate it</span>
          </v-tooltip>
          <v-menu class="text-center">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon class="elevation-3">
                <v-avatar size="32">
                  <v-img :src="flagActualTranslate"></v-img>
                </v-avatar>
              </v-btn>
            </template>
            <v-list v-if="listLanguages">
              <v-list-item
                v-for="(lang, index) in listLanguages"
                :key="index"
                @click="changeLanguage(lang)"
              >
                <v-list-item-action>
                  <v-avatar size="32" class="elevation-3">
                    <v-img :src="lang.flag"></v-img>
                  </v-avatar>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-card-text class="mt-4">
            <v-row justify="center">
              <v-col cols="11">
                 <v-text-field
                    v-model="dialogCreateNewFilter.name[actualTranslateLang]"
                    placeholder="Name"
                    solo
                    flat
                    background-color="#efefef"
                  ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              small
              :disabled="dialogCreateNewFilter.loading"
              @click="closeDialogCreateNewFilter()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              small
              :disabled="dialogCreateNewFilter.loading"
              :loading="dialogCreateNewFilter.loading"
              @click="saveNewCreateFilter()"
            >
              Generate
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteConfirm.show" width="300" class="rounded-xl">
      <v-card class="text-center">
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->
        <v-icon class="text-center ma-2" size="120" color="primary"
          >mdi-alert</v-icon
        >
        <v-card-text class="pa-4 text-center"
          >This action is irreversible and will delete all data about the Tag and Sub-tag.</v-card-text
        >
        <v-card-text class="text-center">Are you sure?</v-card-text>

        <!-- <v-card-actions class="pa-0"> -->
        <!-- <v-spacer></v-spacer> -->

        <v-btn
          color="third"
          tile
          width="150"
          class="pa-0 text--secondary"
          @click="closeDialogDeleteConfirm()"
          >No</v-btn
        >

        <v-btn
          color="primary"
          tile
          width="150"
          class="pa-0"
          @click="openDialogReAuth('deleteRootFilter', dialogDeleteConfirm.item)"
          >Yes</v-btn
        >
        <!-- </v-card-actions> -->
      </v-card>
      </v-dialog>
      <modal-reauth :dialogReAuth="dialogReAuth" @isSuccessReAuth="isSuccessReAuth"></modal-reauth>
    </v-container>
</template>
<script>
import modalReauth from '@/components/admin/modal-reauth.vue';
import { mapGetters } from "vuex";
export default {
  name: "ProTrainersSettings",
  components:{ modalReauth },
  created() {
    let vm = this
    vm.getProTrainerFilterList()
  },
  data: () => ({
    headers:[
        { text: "Name", align: "center", value: "name", sortable: true, },
        { text: "Action", align: "center", value: "action", sortable: false },
    ],
    dialogCreate:{
        show:false,
        type:'',
        name:'',
        loading:false,
    },
    dialogChildrenFilters:{
        show:false,
        type:'',
        item:{},
        newSubfilter:'',
        loading:false,
    },
    dialogThirdLevelFilters:{
        show:false,
        type:'',
        item:{},
        parent: '',
        newThirdLevel:'',
        loading:false,
    },
    dialogCreateNewFilter:{
      show:false,
      loading:false,
      name:{
        ENG:"",
        KOR:"",
        ESP:"",
        JAP:"",
      }
    },
    dialogReAuth:{
      show: false,
      action: '',
      item:{}
    },
    dialogDeleteConfirm:{
      show: false,
      item:{}
    },
    actualTranslateLang:"ENG",
    listLanguages:[
      {
        name:"English",
        code:"ENG",
        flag:require("@/assets/flags/usa-flag.png")
      },
      {
        name:"Japanese",
        code:"JAP",
        flag:require("@/assets/flags/japan-flag.jpg")
      },
      {
        name:"Spanish",
        code:"ESP",
        flag:require("@/assets/flags/spain-flag.png")
      },
      {
        name:"Korean",
        code:"KOR",
        flag:require("@/assets/flags/south-korea-flag.png")
      },
    ]
  }),
  methods: {
    getProTrainerFilterList(){
       let vm = this;
       vm.$emit("showOverlay", true);
        vm.$store.dispatch('GetFiltersListsProTrainer')
        .then((res) => {
          console.log('getProTrainerFilters', this.getProTrainerFilters);
          vm.$emit("showOverlay", false);
        }).catch((err) => {
          vm.$emit("showOverlay", false);
            console.error(err)
        })
    },
    getTypeTextPlaceholder(type){
        if(type === 'areaOfFocus'){ return 'Area of Focus'}else if(type === 'placement'){ return 'Placement'}else if(type === 'trainers'){ return 'Trainer'}else if(type === 'workoutType'){ return 'Workout Type'}
    },
    closeDialogCreate(){
        let vm = this;
        vm.dialogCreate = {
            show:false,
            type:'',
            name:'',
            loading:false,
        }
    },
    openDialogCreate(type){
        let vm = this;
        vm.dialogCreate.show = true
        vm.dialogCreate.type = type
        // vm.dialogCreate.array = array
    },
    saveNewCreate(){
      let vm = this;
      vm.dialogCreate.loading = true 
      let data = {
          name:vm.dialogCreate.name,
          doc:vm.dialogCreate.type,
          children:[],
          // array:vm.dialogCreate.array,
      } 
      vm.$store.dispatch('AddNewTypeToListOfFiltersProTrain', data)
      .then((res)=>{
        vm.$store.dispatch("GenerateLog", {
          name: data.name,
          doc: vm.getTypeTextPlaceholder(data.doc),
          type: "createdNewFilterProTrain",
        });
        let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: "New "+vm.getTypeTextPlaceholder(data.doc)+" created successfully",
            color: "success",
        };
        vm.$emit("showSnackBar", emitData);
        vm.closeDialogCreate()
      }).catch((err)=>{
        vm.dialogCreate.loading = false
        console.error(err)
      })

    },
    isSuccessReAuth(dialogReAuthResponse){
      const vm = this 
        switch (dialogReAuthResponse.action) {
          case 'deleteRootFilter':
            vm.deleteRootFilter(dialogReAuthResponse.item)
            break;
          default:
            break;
        }
    },
    deleteItem(type, item){
      let vm = this;
      let data = {
          item:item,
          // array:array,
          doc:type
      } 
      vm.$store.dispatch('DeleteTypeToListOfFiltersProTrain', data)
      .then((res)=>{
         vm.$store.dispatch("GenerateLog", {
          name: data.name,
          doc: vm.getTypeTextPlaceholder(data.doc),
          type: "deletedFilterProTrain",
        });
        let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: item.name+" deleted successfully",
            color: "dark",
        };
        vm.$emit("showSnackBar", emitData);
      }).catch((err)=>{
        let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 3000,
            text: item.name+" has an error deleting, please restart the page and try again",
            color: "red",
        };
        vm.$emit("showSnackBar", emitData);
        console.error(err)
      })
    },
    openThirdLevelFiltersModal(item, type, parent){
      let vm = this
      vm.dialogThirdLevelFilters = {
        show:true,
        type:type,
        item:item,
        parent:parent,
        newThirdLevel:'',
        loading:false,
      }
      console.log('dialogThirdLevelFilters', vm.dialogThirdLevelFilters);
    },
    openSubfiltersModal(item, type){
      let vm = this
      console.log(item);
      console.log(type);
      vm.dialogChildrenFilters = {
        show:true,
        type:type,
        item:item,
        newSubfilter:'',
        loading:false,
      }
    },
    saveNewSubfilter(){
      let vm = this
      if(vm.dialogChildrenFilters.newSubfilter.length > 0){
        vm.dialogChildrenFilters.loading = true
        let updatedArray = []
        vm.getProTrainerFilters.forEach((filter) => {
          if(filter.type === vm.dialogChildrenFilters.type){
            updatedArray = filter.listFilters.map((subfilter) => {
              if(subfilter.name === vm.dialogChildrenFilters.item.name){
                subfilter.children.push({name: vm.dialogChildrenFilters.newSubfilter, children: []})
              }
              return subfilter
            })
          }
        })
        let data ={
          doc:vm.dialogChildrenFilters.type,
          item:vm.dialogChildrenFilters.item,
          updatedArray:updatedArray
        }
        vm.$store.dispatch('AddOrDeleteChildrenToListOfFiltersProTrain', data)
        .then((res)=>{
           vm.$store.dispatch("GenerateLog", {
            name: vm.dialogChildrenFilters.newSubfilter,
            doc: vm.getTypeTextPlaceholder(data.doc),
            type: "createdSubfilterProtrain",
          });
          let emitData = {
            snackbar: true,
              btn: "",
              y: "bottom",
              x: null,
              mode: "",
              timeout: 2000,
              text: vm.dialogChildrenFilters.newSubfilter+" added successfully",
              color: "dark",
          };
           vm.dialogChildrenFilters.newSubfilter = ''
           vm.dialogChildrenFilters.loading = false
          vm.$emit("showSnackBar", emitData);
        }).catch((err)=>{
           vm.dialogChildrenFilters.loading = false
          let emitData = {
              snackbar: true,
              btn: "",
              y: "bottom",
              x: null,
              mode: "",
              timeout: 3000,
              text: data.newSubfilter+" has an error adding new sub-tag, please restart the page and try again",
              color: "red",
          };
          vm.$emit("showSnackBar", emitData);
          console.error(err)
        })

      }
      
    },
    async saveNewThirdLevelFilter(){
      try {
        const vm = this
        let updatedArray = []
        vm.getProTrainerFilters.forEach((filter) => {
            if(filter.type === vm.dialogThirdLevelFilters.type){
              updatedArray = filter.listFilters.map((subfilter) => {
                if(subfilter.name === vm.dialogThirdLevelFilters.parent){
                  const indexSubFilter = subfilter.children.findIndex(subF => subF.name === vm.dialogThirdLevelFilters.item.name)
                  subfilter.children[indexSubFilter].children.push({ name: vm.dialogThirdLevelFilters.newThirdLevel })
                }
                return subfilter
              })
            }
        })

        let data ={
          doc:vm.dialogThirdLevelFilters.type,
          item:vm.dialogThirdLevelFilters.item,
          updatedArray: updatedArray
        }
        await vm.$store.dispatch('AddOrDeleteChildrenToListOfFiltersProTrain', data)
        
        await vm.$store.dispatch("GenerateLog", {
          name: vm.dialogThirdLevelFilters.newThirdLevel,
          doc: vm.getTypeTextPlaceholder(data.doc),
          type: "createdThirdLevelProtrain",
        });
        let emitData = {
          snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: vm.dialogThirdLevelFilters.newThirdLevel+" added successfully",
            color: "dark",
        };
        vm.dialogThirdLevelFilters.newThirdLevel = ''
        vm.dialogThirdLevelFilters.loading = false
        vm.$emit("showSnackBar", emitData);
        
      } catch (error) {
        vm.dialogThirdLevelFilters.loading = false
          let emitData = {
              snackbar: true,
              btn: "",
              y: "bottom",
              x: null,
              mode: "",
              timeout: 3000,
              text: vm.dialogThirdLevelFilters.newSubfilter+" has an error adding new third level filter, please restart the page and try again",
              color: "red",
          };
          vm.$emit("showSnackBar", emitData);
          console.error(error)
      }
    },
    deleteSubfilter(itemToDelete){
      let vm = this
      vm.dialogChildrenFilters.loading = true
      let indexPrincipal = vm.getProTrainerFilters.findIndex(filter => filter.type === vm.dialogChildrenFilters.type)
      let selectedFilterList = vm.getProTrainerFilters[indexPrincipal].listFilters
      let indexFilterList = selectedFilterList.findIndex(filter => filter.name === vm.dialogChildrenFilters.item.name )
      let indexChildren = vm.dialogChildrenFilters.item.children.findIndex(child => child.name === itemToDelete.name )
      selectedFilterList[indexFilterList].children.splice(indexChildren, 1)
     
      let data ={
        doc:vm.dialogChildrenFilters.type,
        item:vm.dialogChildrenFilters.item,
        updatedArray:selectedFilterList
      }
      vm.$store.dispatch('AddOrDeleteChildrenToListOfFiltersProTrain', data)
      .then((res)=>{
        vm.$store.dispatch("GenerateLog", {
            name: itemToDelete.name,
            doc: vm.getTypeTextPlaceholder(data.doc),
            type: "deletedSubfilterProTrain",
          });

        let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: itemToDelete.name+" deleted successfully",
            color: "dark",
        };
         vm.dialogChildrenFilters.loading = false
        vm.$emit("showSnackBar", emitData);
      }).catch((err)=>{
         vm.dialogChildrenFilters.loading = false
        let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 3000,
            text: itemToDelete.name+" has an error deleting sub-tag, please restart the page and try again",
            color: "red",
        };
        vm.$emit("showSnackBar", emitData);
        console.error(err)
      })
    },
    async deleteThirdLevelFilter(itemToDelete){
      try {
        const vm = this
        vm.dialogThirdLevelFilters.loading = true
        let indexPrincipal = vm.getProTrainerFilters.findIndex(filter => filter.type === vm.dialogThirdLevelFilters.type)
        let selectedFilterList = vm.getProTrainerFilters[indexPrincipal].listFilters
        let indexFilterList = selectedFilterList.findIndex(filter => filter.name === vm.dialogThirdLevelFilters.parent )
        let indexSubFilter =  vm.getProTrainerFilters[indexPrincipal].listFilters[indexFilterList].children.findIndex(subfilter => subfilter.name ===  vm.dialogThirdLevelFilters.item.name)
        let indexThirdLevel = vm.getProTrainerFilters[indexPrincipal].listFilters[indexFilterList].children[indexSubFilter].children.findIndex(thirdLevel => thirdLevel.name === itemToDelete.name)
        selectedFilterList[indexFilterList].children[indexSubFilter].children.splice(indexThirdLevel, 1)

        let data ={
          doc:vm.dialogThirdLevelFilters.type,
          item:vm.dialogThirdLevelFilters.item,
          updatedArray:selectedFilterList
        }
        vm.$store.dispatch('AddOrDeleteChildrenToListOfFiltersProTrain', data)
       
        vm.$store.dispatch("GenerateLog", {
            name: itemToDelete.name,
            doc: vm.getTypeTextPlaceholder(data.doc),
            type: "deletedThirdLevelProTrain",
        });

        let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: itemToDelete.name+" deleted successfully",
            color: "dark",
        };
        vm.dialogThirdLevelFilters.loading = false
        vm.$emit("showSnackBar", emitData);
                
      } catch (error) {
          vm.dialogThirdLevelFilters.loading = false
          let emitData = {
              snackbar: true,
              btn: "",
              y: "bottom",
              x: null,
              mode: "",
              timeout: 3000,
              text: itemToDelete.name+" has an error deleting third level filter, please restart the page and try again",
              color: "red",
          };
          vm.$emit("showSnackBar", emitData);
          console.error(error)   
      }
    },
    closeDialogCreateNewFilter(){
      const vm = this
      vm.dialogCreateNewFilter = {
        show:false,
        loading:false,
        name:{
          ENG:"",
          KOR:"",
          ESP:"",
          JAP:"",
        }
      }
    },
    saveNewCreateFilter(){
      const vm = this
      let emitData = {
        snackbar: true,
        btn: "",
        y: "bottom",
        x: null,
        mode: "",
        timeout: 3000,
        text: "",
        color: "red",
      }
      vm.dialogCreateNewFilter.loading = true
      if(vm.dialogCreateNewFilter.name['ENG'].length > 0){
        if(!vm.getProTrainerFilters.some(filter => filter.type === vm.camelCaseFilterName)){
          let data = {
            name: vm.dialogCreateNewFilter.name,
            listFilters: [],
            doc: vm.camelCaseFilterName
          }
          console.log(data);
           vm.$store.dispatch('CreateNewFilterProTrainer', data)
            .then((res)=>{
              vm.$store.dispatch("GenerateLog", {
                  name: data.name['ENG'],
                  doc: data.doc,
                  type: "createdRootFilterProTrain",
                });
  
              vm.closeDialogCreateNewFilter()
              emitData.text = "Tag generated successfully",
              emitData.color = "success"
              vm.$emit("showSnackBar", emitData);
            }).catch((err)=>{
              vm.dialogCreateNewFilter.loading = false
              emitData.text = "An error has occured generating tag",
              emitData.color = "red"
              vm.$emit("showSnackBar", emitData);
              console.error(err)
            })

        }else{
          vm.dialogCreateNewFilter.loading = false
          emitData.text = "A tag with this name already exists"
          emitData.color = "red"
          vm.$emit("showSnackBar", emitData);
        }

      }else{
        vm.dialogCreateNewFilter.loading = false
        emitData.text = "The name is required in the English language"
        emitData.color = "red"
        vm.$emit("showSnackBar", emitData);
      }

    },
    changeLanguage(lang){
      const vm = this
      vm.actualTranslateLang = lang.code
    },
    openDialogDeleteConfirm(filter){
      const vm = this
      vm.dialogDeleteConfirm = {
        show: true,
        item:filter
      }
    },
    closeDialogDeleteConfirm(){
      const vm = this
      vm.dialogDeleteConfirm = {
        show: false,
        item:{}
      }
    },
    openDialogReAuth(action, item){
      const vm = this;
      vm.dialogReAuth.show = true
      vm.dialogReAuth.action = action
      vm.dialogReAuth.item = item
      vm.closeDialogDeleteConfirm();
    },
    deleteRootFilter(item){
      const vm = this
      vm.$emit("showOverlay", true);
      let emitData = {
        snackbar: true,
        btn: "",
        y: "bottom",
        x: null,
        mode: "",
        timeout: 3000,
        text: "",
        color: "red",
      }
      let data = {
        doc:item.type,
        name:item.name
      }
      vm.$store.dispatch('DeleteFilterProTrainer', data)
            .then((res)=>{
              vm.$store.dispatch("GenerateLog", {
                  name: data.name['ENG'],
                  doc: data.doc,
                  type: "deletedRootFilterProTrain",
                });
              vm.$emit("showOverlay", false);
              emitData.text = "Tag deleted successfully",
              emitData.color = "dark"
              vm.$emit("showSnackBar", emitData);
            }).catch((err)=>{
              vm.$emit("showOverlay", false);
              emitData.text = "An error has occured deleting tag",
              emitData.color = "red"
              vm.$emit("showSnackBar", emitData);
              console.error(err)
            })
    }
  },
  computed:{
      camelCaseFilterName(){
        return this.dialogCreateNewFilter.name['ENG'].replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
          if (/\s+/.test(match)) return '';
          return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
      },
      flagActualTranslate() {
        let vm = this;
        if(vm.listLanguages.length > 0){
          let currentFlag = vm.listLanguages.find(flag => flag.code === vm.actualTranslateLang);
          return currentFlag.flag;
      }
      },
     ...mapGetters(["getProTrainerFilters"]),
     
  }
}
</script>